/**
 * AJAX handler functions to create and edit data from the database
 *
 * Copyright (c) 2016 Improved Software. All rights reserved
 * Author:     Matt Batten <matt@improvedsoftware.com.au>
 * Requires:   [Vendor] PNotify JS + CSS
 *             [System] user-notification.js
*/

// User AJAX object for working with data in the database
var AJXDB = {

   /** ----------------------------------------------------------------------------
    * Execute ajax with callback function for system sections
    *
    * @param  string ajaxURL           The holder of function url
    * @param  string ajaxData          Form details
    * @param  string successCallback   Callback function when success
    * @param  string errorCallback     Callback function when error
    * @param  string link              Result url
    * @param  string id                Details
    */
   ajaxForm: function( ajaxURL, ajaxData, successCallback, errorCallback, id, link, dataType ) {

      if ( typeof( dataType ) === 'undefined' ) dataType = 'json';

      $.ajax({
         type: 'POST',
         url: ajaxURL,
         data: ajaxData,
         dataType: dataType,
         success: function( data ) {
            if ( typeof( successCallback ) == "function" ) {
               successCallback( data, id, link );
            }
         },
         error: function( e ) {
            if ( typeof( errorCallback ) == "function" ) {
               errorCallback( e, id, link );
            }
         }
      });
   },
   
};

MENUHELPER = {

    makeMenuItemActive: function( url ) {

        // for sidebar menu entirely but not cover treeview
        $('ul.sidebar-menu a').filter(function() {
            return this.href == url;
        }).parent().addClass('active');

        $('ul.treeview-menu a').filter(function() {
            return this.href == url;
        }).parent().addClass('active');

        // for treeview
        $('ul.treeview-menu a').filter(function() {
            return this.href == url;
        }).parentsUntil('.sidebar-menu > .treeview-menu').addClass('menu-open').css('display', 'block');
    },
};

decodeHTML = function (html) {
    var txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};


/** ----------------------------------------------------------------------------
 * Uses moment.js to format a date. If an empty string or null is passed it returns 
 * an empty string
 *
 * @param  string momentToConvert   String with date in universal format
 * @param  string requiredFormat    String with required date/time format to return
 * @return {string}                 [Formatted date/time string]
 */
createDateOrEmptyString = function(momentToConvert, requiredFormat) {
    return ( momentToConvert != '' && momentToConvert != null ) ? 
        moment( momentToConvert ).format( requiredFormat ) : 
        '';
}



displayLaravelResponseErrors = function (request) {

    var errors = $.parseJSON(request.responseText);
    $.each(errors, function (key, value) {
        if ($.isPlainObject(value)) {
            $.each(value, function (key, value) {                       
                // The actual error messages
                UN.displayNotice( 'Error', value, 'error' ); 
            });
        } else {
            // Delay the message so it appears at the top
            setTimeout( function() { 
                UN.displayNotice( 'Success', value, 'info' ); 
            }, 500);
        }
    });
}

